import { render, staticRenderFns } from "./Showactgoods.vue?vue&type=template&id=6410fce0&"
import script from "./Showactgoods.vue?vue&type=script&lang=js&"
export * from "./Showactgoods.vue?vue&type=script&lang=js&"
import style0 from "./Showactgoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports